export const paymentStatusValues = [
  {
    value: "Paid",
    label: "Paid",
  },
  {
    value: "Processing",
    label: "Processing",
  },
  {
    value: "Failed",
    label: "Failed",
  },
  {
    value: "Cancelled",
    label: "Cancelled",
  },
  {
    value: "Pending",
    label: "Pending",
  },
];
